import React, { useEffect, useState } from "react";
import Select from "react-select";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import { Link, useLocation, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import DatatableFunc from "../../../Common/DatatableFunc";
import Alert from "../../../Common/Alert";

const GetBankLedgerDetails = () => {
  const location = useLocation();
  const [bankData, setBankData] = useState([]);
  const [banksData, setBanksData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const bankId = useParams().id;

  const getCurrentMonthDates = () => {
    const today = new Date();
    // Get first day of current month
    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`; // Format as YYYY-MM-DD for HTML date inputs
    };

    return {
      firstDate: formatDate(firstDayOfCurrentMonth), // First day of current month in YYYY-MM-DD format
      todayDate: formatDate(today) // Today's date in YYYY-MM-DD format
    };
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/get-bank-ledger-details/${bankId}?start_date=${startDate}&end_date=${endDate}`);
      const resRole = await Http.get(`/staff-type-check`);
      const resBanks = await Http.get(`/accounts/banks`);
      setBanksData(resBanks.data);
      setBankData(res.data.transactions);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  // useEffect(() => {
  //   const dates = getCurrentMonthDates();
  //   setStartDate(dates.firstDate);
  //   setEndDate(dates.todayDate)
  //   DatatableFunc();
  //   fetchData();
  // }, []);

  useEffect(() => {
    const dates = getCurrentMonthDates();
    setStartDate(dates.firstDate);
    setEndDate(dates.todayDate);
    DatatableFunc();
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);
  const cols = [
    { field: "date", header: "Date" },
    { field: "type", header: "Transaction Type" },
    { field: "opening_balance", header: "Opening Balance" },
    { field: "amount", header: "Amount" },
    { field: "balance", header: "Balance" },
  ];

  const selectHandleChange = async (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption.value;

    if (name === "bank_id") {
      try {
        const res = await Http.get(`/accounts/get-bank-ledger-details/${value}?start_date=${startDate}&end_date=${endDate}`);
        setBankData(res.data.transactions);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    }
  };
  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Bank Ledger Details</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="col-lg" style={{ zIndex: 999 }}>
                  <div className="form-group">
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={banksData.find(bank => bank.id == bankId) ? {
                        value: banksData.find(bank => bank.id == bankId).id,
                        label: banksData.find(bank => bank.id == bankId).name
                      } : null}
                      name="bank_id"
                      options={banksData.map((bank) => ({
                        value: bank.id,
                        label: bank.name,
                      }))}
                      onChange={selectHandleChange}
                    />
                  </div>
                </div>
                <div className="col-lg" >
                  <div className="form-group">
                    <input type="date" className="form-control" name="start_date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  </div>
                </div>
                <div className="col-lg" >
                  <div className="form-group">
                    <input type="date" className="form-control" name="end_date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={bankData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetBankLedgerDetails